document.addEventListener('DOMContentLoaded', function() {

  //Prevenir en el footer enlaces externos en la misma ventana
  const footerLinks = document.querySelectorAll('.footer .thb-widget-menu li a');
  for (const enlace of footerLinks) {
      const urlElemento = enlace.href;
      // Verifica si la URL del elemento no contiene la URL del SignIn de CJ
      if (!urlElemento.includes('di4-home.com') && !urlElemento.includes('3yyeza-uj.myshopify.com')) {
        enlace.setAttribute('target', '_blank'); 
      }
  }
  

  
}); //DOMContentLoaded


//Formulario devoluciones
if (window.location.href.includes('cambios-y-devoluciones')) {
    document.addEventListener('DOMContentLoaded', function () {
      const elem = document.querySelector('div[data-forms-id="forms-root-366369"]');
      const FORM_SELECTOR = 'form-embed#app-embed';
    
      if (!elem) {
        console.warn('⚠️ Nodo contenedor no encontrado');
        return;
      }
    
      function ejecutarLogica() {
        const shadowHost = document.querySelector(FORM_SELECTOR);
        if (!shadowHost) return;
    
        const shadowRoot = shadowHost.shadowRoot;
        if (!shadowRoot) return;
    
        const numPedido = shadowRoot.querySelector('input[id*="nmero_de_pedido"]');
        if (!numPedido) return;
    
        console.log("✅ Ejecutando lógica sobre form-embed");
    
        const textareaDevolucion = shadowRoot.querySelector('form textarea[name*="motivo"]');
        if (textareaDevolucion) {
          textareaDevolucion.parentElement.style.cssText = 'display: none;';
          textareaDevolucion.dispatchEvent(new Event('input', { bubbles: true }));
        }
    
        const numPedidoLabel = shadowRoot.querySelector('label[for*="nmero_de_pedido"]');
        if (numPedidoLabel) {
          numPedidoLabel.style.cssText = 'transform: var(--input-label-transform); width: 100%; min-width: 0;';
        }
    
        const form = shadowRoot.querySelector('form');
        if (!form) return;
    
        const fechaCompraLabel = form.querySelector('[data-testid="date-birthday"] ._birthdayText_rzr7e_15');
        if (fechaCompraLabel) {
          fechaCompraLabel.innerHTML = 'Fecha de la compra*<br/><span style="font-size:13px;font-style: italic;color: grey;">Recuerde que solo se aceptarán las devoluciones los primeros 14 días tras la fecha de compra.</span>';
        }
    
        const submitBtn = form.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.style.cssText = 'padding: 17.313px;font-weight: 500;';
    
        const disclaimer = shadowRoot.querySelector('[class*="_formDisclaimer_"]');
        if (disclaimer) disclaimer.style.cssText = 'text-align: left;font-size: 11px;';
    
        const inputs = form.querySelectorAll('input');
        inputs.forEach(input => {
          input.style.cssText = 'border-radius: 4px;padding-top: 25.5px;';
          input.addEventListener('focus', () => {
            if (input.matches(':focus-visible')) input.style.cssText += 'box-shadow: 0 0 0 2px #2c2d2e;';
          });
          input.addEventListener('blur', () => {
            input.style.cssText = 'border-radius: 4px;padding-top: 25.5px;';
          });
        });
    
        const inputDni = form.querySelector('#custom#dni');
        if (inputDni) {
          inputDni.addEventListener('input', function () {
            if (this.value.length > 9) {
              this.value = this.value.substring(0, 9);
            }
          });
        }
    
        const selectors = form.querySelectorAll('button[aria-controls]');
        selectors.forEach(selector => {
          const valorDefecto = document.createElement('span');
          valorDefecto.textContent = 'Elige una opción';
          valorDefecto.style.cssText = 'display: block;width: 100%;';
          selector.prepend(valorDefecto);
    
          const spans = selector.querySelectorAll('span');
          const textElement = spans.length >= 2 ? spans[1] : null;
    
          selector.style.cssText = 'border-radius: 4px;max-height: 50px;height: 50px;';
          selector.addEventListener('click', () => {
            if (selector.matches("[aria-expanded='false']")) {
              selector.style.cssText += 'box-shadow: 0 0 0 2px #2c2d2e;';
            } else {
              selector.style.cssText = 'border-radius: 4px;max-height: 50px;height: 50px;';
            }
          });
    
          const observerSelector = new MutationObserver(() => {
            if (!textElement) return;
    
            valorDefecto.style.display = textElement.textContent.trim() === '' ? 'block' : 'none';
    
            if (
              selector.getAttribute('aria-controls') === 'custom#motivo_de_la_devolucin-selector-dropdown' &&
              textareaDevolucion
            ) {
              const value = textElement.textContent.trim();
              textareaDevolucion.parentElement.style.cssText =
                value === 'Otro (describir)' ? 'display: flex;' : 'display: none;';
            }
          });
    
          observerSelector.observe(selector, { childList: true, subtree: true });
        });
    
        const textareas = form.querySelectorAll('textarea');
        textareas.forEach(area => {
          area.style.cssText = 'border-radius: 4px;padding-top: 25.5px;';
          area.addEventListener('focus', () => {
            if (area.matches(':focus-visible')) area.style.cssText += 'box-shadow: 0 0 0 2px #2c2d2e;';
          });
          area.addEventListener('blur', () => {
            area.style.cssText = 'border-radius: 4px;padding-top: 25.5px;';
          });
        });
      }
    
      // Espera activa si se inserta dinámicamente
      function esperarYejecutarLogica(intentos = 20) {
        const shadowHost = document.querySelector(FORM_SELECTOR);
        if (!shadowHost || !shadowHost.shadowRoot) {
          if (intentos > 0) {
            return setTimeout(() => esperarYejecutarLogica(intentos - 1), 200);
          } else {
            console.warn('⛔ No se cargó el shadowRoot tras varios intentos.');
            return;
          }
        }
    
        const shadowRoot = shadowHost.shadowRoot;
        const numPedido = shadowRoot.querySelector('input[id*="nmero_de_pedido"]');
    
        if (!numPedido) {
          if (intentos > 0) {
            return setTimeout(() => esperarYejecutarLogica(intentos - 1), 200);
          } else {
            console.warn('⛔ Input "custom#nmero_de_pedido" no encontrado tras varios intentos.');
            return;
          }
        }
    
        console.log('✅ Ejecutando lógica tras espera activa');
        ejecutarLogica();
      }
    
      const formAlreadyInDOM = document.querySelector(FORM_SELECTOR);
    
      if (formAlreadyInDOM) {
        console.log('✅ form-embed ya está en el DOM, ejecutando lógica directamente');
        esperarYejecutarLogica();
      } else {
        console.log('⌛ Esperando que se inserte form-embed…');
    
        const observer = new MutationObserver(mutations => {
          for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType === 1 && node.matches(FORM_SELECTOR)) {
                console.log('📢 Mutación detectada: form-embed insertado');
                observer.disconnect();
                esperarYejecutarLogica();
                break;
              }
            }
          }
        });
    
        observer.observe(elem, { childList: true });
      }
    });//DOMContentLoaded
} //window.location.href
//END Formulario devoluciones


// Evita el funcionamiento normal del primer item de promociones (bloque justo después del slider) y activa el popup de klaviyo
if (window.location.pathname === '/') {
  document.addEventListener('DOMContentLoaded', function() {

    
    var is_iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (is_iOS) {
      document.querySelectorAll('.section-promotion-blocks .promotion-blocks--item')[0].addEventListener('touchstart touchmove touchend', function (e) {
        e.preventDefault();
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'THuZer']);
      });
    }
    
  
    document.querySelectorAll('.section-promotion-blocks .promotion-blocks--item')[0].removeAttribute('onclick');
    document.querySelectorAll('.section-promotion-blocks .promotion-blocks--item')[0].ontouchstart = null;
  
    document.querySelectorAll('.section-promotion-blocks .promotion-blocks--item')[0].onclick = null;
    document.querySelectorAll('.section-promotion-blocks .promotion-blocks--item')[0].addEventListener('click', function (e){
      e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'THuZer']);
    });
  });
}
//END Evita el funcionamiento normal del primer item de promociones (bloque justo después del slider) y activa el popup de klaviyo


//Modificar forma de estrellas LAI reviews (no-iframe)
const iconCustom = {
  star: {
    rating: `<svg data-customized="true" xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 121 102" preserveAspectRatio="xMidYMid meet"><g transform="translate(0,102) scale(0.1,-0.1)"><path d="M548 1015 c-3 -6 -31 -88 -62 -182 l-58 -173 -191 -2 -192 -3 153 -108 c83 -60 152 -113 152 -117 0 -5 -25 -86 -56 -180 -30 -95 -54 -173 -52 -175 2 -2 72 46 156 107 l153 110 155 -111 c85 -61 156 -111 159 -111 2 0 -23 80 -56 177 -32 98 -58 181 -57 185 2 5 72 57 157 118 l154 110 -194 0 -194 0 -61 182 c-33 100 -63 178 -66 173z"/></g></svg>`,
    none: `<svg data-customized="true" xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 121 102" preserveAspectRatio="xMidYMid meet"><g transform="translate(0,102) scale(0.1,-0.1)"><path d="M548 1015 c-3 -6 -31 -88 -62 -182 l-58 -173 -191 -2 -192 -3 153 -108 c83 -60 152 -113 152 -117 0 -5 -25 -86 -56 -180 -30 -95 -54 -173 -52 -175 2 -2 72 46 156 107 l153 110 155 -111 c85 -61 156 -111 159 -111 2 0 -23 80 -56 177 -32 98 -58 181 -57 185 2 5 72 57 157 118 l154 110 -194 0 -194 0 -61 182 c-33 100 -63 178 -66 173z"/></g></svg>`
  }
};

function replaceStars() {
  // Estrellas llenas
  document.querySelectorAll('svg .Path_1_').forEach(path => {
    const svg = path.closest('svg');
    if (svg && !svg.hasAttribute('data-customized')) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = iconCustom.star.rating;
      svg.replaceWith(wrapper.firstElementChild);
    }
  });

  // Estrellas vacías
  document.querySelectorAll('svg.svg_none').forEach(svg => {
    if (!svg.hasAttribute('data-customized')) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = iconCustom.star.none;
      svg.replaceWith(wrapper.firstElementChild);
    }
  });
}

let timeout;
const observer = new MutationObserver(() => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    replaceStars();
  }, 300);
});

function observeContainers() {
  const containers = document.querySelectorAll('.product-information, .product-card-info');
  containers.forEach(container => {
    observer.observe(container, {
      childList: true,
      subtree: true
    });
  });
}

// Esperar que el DOM esté listo y lanzar la observación
document.addEventListener('DOMContentLoaded', () => {
  observeContainers();
  // Reemplazar por si ya hay estrellas al cargar la página
  replaceStars();
});
//END Modificar forma de estrellas LAI reviews (no-iframe)